import React from "react";
import Welcome from "../master_pobox";
import { Button, Form, Modal, Alert } from "react-bootstrap";
import CatArancel from "../Components/Servicios/CatArancel";
import apiUrl from "../enviroments/enviroment";
import cogoToast from "cogo-toast";
import axios from "axios";
import swal from "sweetalert";

class Cotizacion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ModalCotizacion: false,
            cotizacion: [],
            paises: [
                { value: "1", label: "USA" },
                { value: "2", label: "Unión Europea" },
                { value: "3", label: "Colombia" },
                { value: "4", label: "China" }
            ],
            CmbAranceles: '',
            TxtPeso: '',
            TxtValFact: '',
            txtalto: '0',
            txtancho: '0',
            txtlargo: '0',
            txtpais: '',
            mostrarCamposDimensiones: false,
            txtmoneda: '1',
            monedas: {
                '1': ['1'], // USA: Solo Dólar (1)
                '2': ['1', '3'], // Unión Europea: Dólar (1) y Euro (3)
                '3': ['1', '2'], // Colombia: Dólar (1) y Peso colombiano (2)
                '4': ['1'], // China: Solo Dólar (1)
            },
        };
    }

    handleChange = e => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        // Verifica si el país seleccionado es China
        if (name === 'txtpais') {
            if (value === '4') {
                this.setState({ mostrarCamposDimensiones: true, txtmoneda: this.state.monedas[value][0] || 'USD' });
            } else {
                this.setState({ mostrarCamposDimensiones: false, txtmoneda: this.state.monedas[value][0] || 'USD' });
            }
        }
    }

    // Manejador para actualizar la moneda seleccionada
    handleMonedaChange = (event) => {
        const { value } = event.target;
        this.setState({ txtmoneda: value });
    };
    /*handleChange = (event) => {
        const { value } = event.target;
        this.setState(
        {
            txtpais: value, // Actualiza el valor del país seleccionado
        },
        () => {
            // Verifica si el país seleccionado es China
            if (value === '4') {
            this.setState({ mostrarCamposDimensiones: true });
            } else {
            this.setState({ mostrarCamposDimensiones: false });
            }
        }
        );
    };*/

    validateFields = () => {
        const { CmbAranceles, TxtPeso, TxtValFact } = this.state;
        if (!CmbAranceles || !TxtPeso || !TxtValFact) {
            cogoToast.warn("Todos los campos son necesarios para continuar");
            return false;
        }
        return true;
    }

    onSubmit = e => {
        e.preventDefault();
        if (!this.validateFields()) return;

        let { CmbAranceles, TxtPeso, TxtValFact, txtpais, txtalto, txtancho, txtlargo, txtmoneda } = this.state;

        let peso = parseFloat(TxtPeso);
        if (peso > 79.9) {
            this.showWhatsappAlert();
            return;
        }

        const data = {
            seccion: localStorage.getItem('seccion'),
            direccion: CmbAranceles,
            telefono: TxtPeso,
            nombre_entrega: TxtValFact
        };
        console.log(txtmoneda);
        let url = apiUrl.apiUrl + "cotizacion_con_seccionv3/" + localStorage.getItem('seccion') + "/" + TxtValFact + "/" + TxtPeso + "/" + CmbAranceles + "/" + txtpais + "/" + txtalto + "/" + txtancho + "/" + txtlargo + "/" + txtmoneda;

        axios.get(url, {
            headers: {
                userid: 'transexpress',
                pwduser: 'JTOYV9IlFarK6G2jPRo7dJxkmfHOhD9S',
            }
        }).then(response => {
            this.handleApiResponse(response.data[0]);
        }).catch(error => {
            swal("Ayuda", "Ha ocurrido un error, contactate con el administrador del sitio web", "error");
        });
    }

    handleApiResponse = (data) => {
        const gastos_mercaderia = data.gastos_de_mercaderia * 1;
        const gastos_flete = data.gastos_flete * 1;
        const seguro = data.seguro * 1;
        const tipo_cambio = data.tipo_cambio * 1;
        const cif = (gastos_mercaderia + gastos_flete + seguro) / tipo_cambio;

        if (cif > 1000) {
            this.showWhatsappAlert();
            return;
        }

        this.setState({
            cotizacion: data,
            ModalCotizacion: true
        });
    }

    showWhatsappAlert = () => {
        swal({
            title: "Información",
            text: "Por requisitos especiales de importación, favor cotizar al 502-54939039",
            icon: "error",
            button: "Ir a Whatsapp",
        })
        .then(() => {
            let number = '+502-54939039';
            let message = "Por requisitos especiales de importación, favor cotizar al 502-54939039";
            const url = `https://wa.me/${number.replace(/[^\w\s]/gi, '').replace(/ /g, '')}?text=${encodeURI(message)}`;
            window.open(url);
        });
    }

    generateTableRows = () => {
        const { cotizacion } = this.state;
        const rows = [
            { label: "Valor de Mercadería", value: cotizacion.gastos_de_mercaderia },
            { label: "Gastos de Flete", value: cotizacion.gastos_flete },
            { label: "Impuestos en Guatemala", value: cotizacion.impuestos_guatemala },
            { label: "Gestión y Desconsolidación", value: cotizacion.gestion },
            { label: "Resguardo", value: cotizacion.resguardo },
        ];

        return rows.map((row, index) => (
            <tr key={index}>
                <td><h4><b>{row.label}: </b></h4></td>
                <td><h4>Q. {(Math.round(row.value * 100) / 100).toFixed(2)}</h4></td>
            </tr>
        ));
    }

    render() {
        const { txtpais, mostrarCamposDimensiones, paises, txtalto, txtancho, txtlargo, monedas, txtmoneda } = this.state;
        const monedasDisponibles = monedas[txtpais] || ['1'];
        return (
            <Welcome>
                <main id="js-page-content" role="main" className="page-content" style={{ backgroundColor: "#000e2e" }}>
                    <div className="subheader">
                        <h1 className="subheader-block">
                            <i className="fal fa-info-circle" />
                            <label className="label letras">
                                Cotización
                            </label>
                        </h1>
                    </div>
                    <div className="fs-lg fw-300 p-5 bg-white border-faded rounded mb-g">
                        <div className="panel-content">
                            <form>
                                <div className="form-group">
                                    <label className="form-label">País</label>
                                    <Form.Control
                                        as="select"
                                        name="txtpais"
                                        value={txtpais}
                                        onChange={this.handleChange}
                                    >
                                        <option value="0">Seleccione un país</option>
                                        {paises.map(opt => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </Form.Control>
                                </div>
                                {/* Campo de selección de moneda */}
                                <div className="form-group">
                                    <label className="form-label">Moneda</label>
                                    <Form.Control
                                    as="select"
                                    name="txtmoneda"
                                    value={txtmoneda}
                                    onChange={this.handleMonedaChange}
                                    disabled={!txtpais} // Deshabilitar si no se ha seleccionado un país
                                    >
                                    {monedasDisponibles.map((moneda) => (
                                        <option key={moneda} value={moneda}>
                                        {moneda === '1' ? 'Dólar (USD)' : moneda === '2' ? 'Peso Colombiano (COP)' : 'Euro (EUR)'}
                                        </option>
                                    ))}
                                    </Form.Control>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">Aranceles</label>
                                    <Form.Control
                                        as="select"
                                        name="CmbAranceles"
                                        value={this.state.CmbAranceles}
                                        onChange={this.handleChange}
                                    >
                                        <option value="">Seleccione un tipo mercader&iacute;a</option>
                                        <CatArancel />
                                    </Form.Control>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Peso de la Mercadería</label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        name="TxtPeso"
                                        value={this.state.TxtPeso}
                                        placeholder="Ingrese el peso"
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Valor de la Factura {txtmoneda === '1' ? 'Dólar (USD)' : txtmoneda === '2' ? 'Peso Colombiano (COP)' : 'Euro (EUR)'}</label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        name="TxtValFact"
                                        value={this.state.TxtValFact}
                                        placeholder="Ingrese el valor de la factura"
                                        onChange={this.handleChange}
                                    />
                                </div>

                                {/* Campos de dimensiones, solo se habilitan si el país es China */}
                                {mostrarCamposDimensiones && (
                                    <div>
                                    <div className="form-group">
                                        <label className="form-label">Alto</label>
                                        <Form.Control
                                        type="number"
                                        name="txtalto"
                                        value={txtalto}
                                        onChange={this.handleChange}
                                        placeholder="Ingrese el alto"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Ancho</label>
                                        <Form.Control
                                        type="number"
                                        name="txtancho"
                                        value={txtancho}
                                        onChange={this.handleChange}
                                        placeholder="Ingrese el ancho"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Largo</label>
                                        <Form.Control
                                        type="number"
                                        name="txtlargo"
                                        value={txtlargo}
                                        onChange={this.handleChange}
                                        placeholder="Ingrese el largo"
                                        />
                                    </div>
                                    </div>
                                )}

                                <Button variant="primary" block onClick={this.onSubmit}>Calcular Compra</Button>
                            </form>
                        </div>
                    </div>
                </main>

                <Modal show={this.state.ModalCotizacion} onHide={() => this.setState({ ModalCotizacion: false })} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title as="h2"></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Alert>
                            <img src="src/img/logo_transexpress.png" width="75%" className="center" />
                            <Alert.Heading>
                                <label className="label tran"><h1><b>Datos de su Cotización</b></h1></label>
                            </Alert.Heading>
                            <hr />
                            <table>
                                {this.generateTableRows()}
                                <tr>
                                    <td style={{ backgroundColor: "#2196F3" }}><h4><b>Total:</b></h4></td>
                                    <td style={{ backgroundColor: "#2196F3" }}>
                                        <h4>Q. {(Math.round(this.state.cotizacion.total * 100) / 100).toFixed(2)}</h4>
                                    </td>
                                </tr>
                            </table>

                            <label className="label tran">
                                <h4><b>Información Adicional</b></h4>
                            </label>

                            <table>
                                <tr>
                                    <td><h4><b>Peso Cotizado: </b></h4></td>
                                    <td><h4>Lbs. {this.state.TxtPeso}</h4></td>
                                </tr>
                                <tr>
                                    <td><h4><b>Valor de la Mercadería: </b></h4></td>
                                    <td><h4>{txtmoneda === '1' ? 'Dólar (USD)' : txtmoneda === '2' ? 'Peso Colombiano (COP)' : 'Euro (EUR)'} {this.state.TxtValFact}</h4></td>
                                </tr>
                            </table>

                            <label className="label dangerletra">
                                <b><h4>IMPORTANTE:</h4></b>
                            </label><br />
                            <h4><b>* Los gastos de importación pueden variar si el peso o valor cambian</b></h4>
                        </Alert>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ ModalCotizacion: false })}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Welcome>
        );
    }
}

export default Cotizacion;
